<template>
<div id="loader">
  <div class='loader-container'>
    <div class='loader'>
      <svg xmlns="http://www.w3.org/2000/svg" width="850" height="850" viewBox="0 0 850 850">
        <g id='circles'>
          <circle class='bg' fill="none" stroke-width="10" stroke-miterlimit="10" cx="425" cy="425" r="400"/>
          <circle class='fast' fill="none" stroke="#000" stroke-width="10" stroke-miterlimit="10" cx="425" cy="425" r="400"/>
          <circle class='slow' fill="none" stroke-width="10" stroke-miterlimit="10" cx="425" cy="425" r="400"/>
        </g>
        <g id='hexas'>
          <path d="M334.145 358.92c-2.7 1.56-7.12 1.56-9.82 0l-77.152-44.545c-2.7-1.56-4.91-5.386-4.91-8.504v-89.086c0-3.118 2.21-6.945 4.91-8.504l77.154-44.545c2.7-1.56 7.12-1.56 9.82 0l77.152 44.544c2.7 1.558 4.91 5.385 4.91 8.503v89.09c0 3.117-2.21 6.944-4.91 8.503l-77.155 44.544z"/>
          <path d="M521.262 359.014c-2.7 1.56-7.12 1.56-9.82 0L434.29 314.47c-2.7-1.56-4.91-5.387-4.91-8.505v-89.087c0-3.118 2.208-6.945 4.91-8.504l77.153-44.545c2.7-1.56 7.12-1.56 9.82 0l77.152 44.542c2.7 1.56 4.91 5.386 4.91 8.504v89.09c0 3.117-2.21 6.944-4.91 8.503l-77.153 44.544z"/>
          <path d="M614.9 521.2c-2.7 1.56-7.118 1.56-9.818 0l-77.153-44.543c-2.7-1.56-4.91-5.386-4.91-8.504v-89.088c0-3.118 2.208-6.945 4.91-8.504l77.153-44.544c2.7-1.56 7.12-1.56 9.82 0l77.15 44.544c2.7 1.56 4.91 5.386 4.91 8.504v89.09c0 3.117-2.208 6.943-4.91 8.503L614.902 521.2z"/>
          <path d="M521.424 683.294c-2.7 1.56-7.12 1.56-9.82 0l-77.153-44.545c-2.7-1.56-4.91-5.387-4.91-8.505v-89.088c0-3.118 2.21-6.944 4.91-8.504l77.156-44.543c2.7-1.56 7.12-1.56 9.82 0l77.15 44.543c2.7 1.56 4.91 5.386 4.91 8.504v89.09c0 3.118-2.208 6.944-4.91 8.504l-77.152 44.544z"/>
          <path d="M333.73 683.534c-2.7 1.56-7.118 1.56-9.818 0L246.76 638.99c-2.7-1.56-4.91-5.385-4.91-8.503v-89.09c0-3.118 2.21-6.944 4.91-8.504l77.153-44.543c2.7-1.56 7.12-1.56 9.82 0l77.152 44.543c2.7 1.56 4.91 5.386 4.91 8.504v89.088c0 3.118-2.21 6.944-4.91 8.504l-77.154 44.544z"/>
          <path d="M240.09 521.345c-2.7 1.56-7.118 1.56-9.818 0l-77.153-44.543c-2.7-1.56-4.91-5.386-4.91-8.504V379.21c0-3.118 2.21-6.945 4.91-8.504l77.153-44.545c2.7-1.558 7.12-1.558 9.82 0l77.152 44.545c2.7 1.56 4.91 5.386 4.91 8.504v89.088c0 3.118-2.21 6.944-4.91 8.504l-77.154 44.543z"/>
          <path d="M427.785 521.106c-2.7 1.56-7.12 1.56-9.82 0l-77.152-44.545c-2.7-1.56-4.91-5.385-4.91-8.503V378.97c0-3.118 2.21-6.945 4.91-8.504l77.153-44.545c2.7-1.558 7.12-1.558 9.82 0l77.153 44.545c2.7 1.56 4.91 5.386 4.91 8.504v89.087c0 3.118-2.21 6.944-4.91 8.504l-77.155 44.546z"/>    
        </g>
      </svg>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'overwatchLoader'
}
</script>

<style lang="scss">
$time: 3s;
$delay: $time / 14;
$hexa-color: #556c82;
$circle-bg-color: #e3e4dc;
$circle-slow-color: #98938f;
$circle-fast-color: #cac3bf;

#hexas path {
  fill: $hexa-color;
}

#circles {
  .bg {
    stroke: $circle-bg-color;
  }
  .slow {
    stroke: $circle-slow-color;
    animation: slowdash $time linear infinite,
               rotate $time linear infinite;
    transform-origin: 50% 50%;
  }
  .fast {
    stroke: $circle-fast-color;
    animation: fastdash $time linear infinite,
               rotate $time linear infinite;
    transform-origin: 50% 50%;
  }
}

@for $i from 0 through 6  {
  #hexas path:nth-child( #{$i + 1} ){
    animation: hexa $time #{$i * $delay} infinite;
    transform-origin: 50% 50%;
  }
}

// keyframes
@keyframes slowdash {
  0%, 100% {
    stroke-dasharray: 100, 2500;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 200, 2500;
    stroke-dashoffset: -100;
  }
}

@keyframes rotate {
  0%{
    transform: rotate(-45deg);
  }

  50% {
    transform: rotate(135deg);
  }
  100%{
    transform: rotate(315deg);
  }
}

@keyframes fastdash {
  0% {
    stroke-dasharray: 1, 2500;
  }
  25% {
    stroke-dasharray: 1900, 2500;
    stroke-dashoffset: -100;
  }
  75% {
    stroke-dasharray: 2100, 2500;
    stroke-dashoffset: -400;
  }
  100% {
    stroke-dasharray: 2500, 2500;
    stroke-dashoffset: -2500;
  }
}

@keyframes hexa {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  15%, 50% {
    transform: scale(0.5);
    opacity: 0;
  }
  65% {
    transform: scale(1);
    opacity: 1;
  }
}

// layout

#loader {
  height : 100vh;
  position: absolute;
  opacity: 0.2;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
}
.loader-container {
  &:before {
    display: inline-block;
    vertical-align: middle;
    content: " ";
    height: 100%;
  }
  position: relative;
  text-align: center;
  height : 100%;
}

.loader {
  display: inline-block;
  vertical-align: middle;
  
  height: 80vh;
  
  svg {
    width :100%;
    height : 100%;
  }
  
}
</style>


// WEBPACK FOOTER //
// src/components/loader/overwatch.vue